import { getValueAsString } from "@gtmhub/util";

export function cut() {
  return function (value: string | number, wordwise: boolean, max: number, tail: string) {
    let valueToCut = getValueAsString(value);

    if (!max || typeof max !== "number" || valueToCut.length <= max) {
      return valueToCut;
    }

    valueToCut = valueToCut.substring(0, max);
    if (wordwise) {
      let lastspace = valueToCut.lastIndexOf(" ");
      if (lastspace !== -1) {
        if (valueToCut.charAt(lastspace - 1) === ".") {
          lastspace = lastspace - 1;
        }
        valueToCut = valueToCut.substring(0, lastspace);
      }
    }

    return valueToCut + (tail || "...");
  };
}
